import React from "react";

export const NUM = 8;

export default {
  exp_1: {
    id: "exp_1",
    index: 1,
    destacado: false,
    epi: "Último",
    title: "El ascensorista espacial",
    date: "2020-06-15",
    creditos: "Calvichis",
    info: (
      <p>
        Dibujo: J. Domínguez. Guión:{" "}
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
        </a>.
      </p>
    )
  },
  exp_2: {
    id: "exp_2",
    index: 2,
    destacado: false,
    epi: "Último",
    title: "Responsabilidad",
    date: "2020-06-22",
    creditos: "Calvichis",
    info: (
      <p>
        Dibujo: J. Domínguez. Guión: {" "}
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
        </a>.
      </p>
    )
  },
  exp_3: {
    id: "exp_3",
    index: 3,
    destacado: false,
    epi: "Último",
    title: "Mantenimiento",
    date: "2020-06-29",
    creditos: "Calvichis",
    info: (
      <p>
        Dibujo: JJ. Domínguez. Guión: {" "}
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
        </a>.
      </p>)
  },
  exp_4: {
    id: "exp_4",
    index: 4,
    destacado: false,
    epi: "Último",
    title: "Distancia social",
    date: "2020-07-06",
    creditos: "Calvichis",
    info: (
      <p>
        Dibujo: JJ. Domínguez. Guión: {" "}
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
      </a>.
      </p>
    )
  },
  exp_5: {
    id: "exp_5",
    index: 5,
    destacado: false,
    epi: "Último",
    title: "Balneario nudista",
    date: "2020-07-13",
    creditos: "Calvichis",
    info: (
      <p>
        Dibujo: JJ. Domínguez. Guión: {" "}
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
      </a>.
      </p>
    )
  },
  exp_6: {
    id: "exp_6",
    index: 6,
    destacado: false,
    epi: "Último",
    title: "Cambio",
    date: "2020-07-20",
    creditos: "Calvichis",
    info: (
      <p>
        Dibujo: JJ. Domínguez. Guión: {" "}
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
      </a>.
      </p>
    )
  },
  exp_7: {
    id: "exp_7",
    index: 7,
    destacado: true,
    epi: "Último",
    title: "El mago",
    date: "2020-07-27",
    creditos: "Calvichis",
    info: (
      <p>
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
      </a>, Calvichis.
      </p>
    )
  },
  exp_8: {
    id: "exp_8",
    index: 8,
    destacado: true,
    epi: "Último",
    title: "Pasos de baile",
    date: "2020-08-03",
    creditos: "Calvichis",
    info: (
      <p>
        <a
          href="https://www.instagram.com/francisco_asencio/"
          title="Francisco Asencio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Francisco Asencio
      </a>, Calvichis.
      </p>
    )
  }
};
